import React, { useCallback, useState } from "react";
import { Lightbox } from "react-modal-image";
import { Modal, ModalBody, ModalHeader } from "../modal/Modal.jsx";
import { format } from "date-fns";

import personLogo from "../../assets/img/users/user-base64/default";
import CONSTANT from "../../constants/Constant";
import ExerciseTrackingForm from "./ExerciseTrackingForm";
import ExercisesPlanningForm from "./ExercisesPlanningForm";
import VideoModal from "../shared/VideoModal";
import ExercisesTrackingDetails from "./ExercisesTrackingDetails";
import "../../assets/sass/components/my-exercises/_exerciseDetails.scss";

const ExerciseDetails = (props) => {
    const { exercise, getMyExercises } = props;
    const [openExerciseTrackingFormModal, setOpenExerciseTrackingFormModal] = useState(false);
    const [openViewTrackingDetailsModal, setOpenViewTrackingDetailsModal] = useState(false)
    const [showExerciseImage, setShowExerciseImage] = useState(false);
    const [selectedExerciseImage, setSelectedExerciseImage] = useState('');
    const [openVideoTutorial, setOpenVideoTutorial] = useState(false);
    const [videoTutorialUrl, setVideoTutorialUrl] = useState('');
    const [openExercisePlanningFormModal, setOpenExercisePlanningFormModal] = useState(false);

    const toggleExerciseTrackingFormModal = () => {
        if (exercise.ExercisePlan.StartDate && exercise.ExercisePlan.EndDate) {
            setOpenExerciseTrackingFormModal(!openExerciseTrackingFormModal);
        } else {
            toggleExercisePlanningFormModal();
        }
    }

    const toggleExercisePlanningFormModal = () => {
        setOpenExercisePlanningFormModal(!openExercisePlanningFormModal);
    }

    const toggleViewTrackingDetails = () => {
        setOpenViewTrackingDetailsModal(!openViewTrackingDetailsModal);
    }

    const onSaveExerciseTracking = async () => {
        toggleExerciseTrackingFormModal()
        await getMyExercises();
    }

    const onClickExerciseImage = (exerciseImage) => {
        setSelectedExerciseImage(exerciseImage);
        toggleExerciseImage();
    }

    const toggleExerciseImage = () => {
        setShowExerciseImage(!showExerciseImage);
    }

    const toggleVideoTutorialModal = () => {
        setOpenVideoTutorial(!openVideoTutorial);
    }

    const onclickOpenTutorial = (tutorialUrl) => {
        setVideoTutorialUrl(tutorialUrl)
        toggleVideoTutorialModal();
    }

    const onSaveExercisePlan = useCallback(async () => {
        toggleExercisePlanningFormModal()
        await getMyExercises();
        // eslint-disable-next-line react-hooks/exhaustive-deps,
    }, [openExercisePlanningFormModal]);

    // const isExerciseCompleted = () => {
    //     return exercise.Status === CONSTANT.STATUS.COMPLETED;
    // }

    // const getBadgeProgressColor = () => {
    //     return isExerciseCompleted() ? 'kt-badge--success' : 'kt-badge--warning'
    // }
    //
    // const getBgProgressColor = () => {
    //     return isExerciseCompleted() ? 'kt-bg-success' : 'kt-bg-warning'
    // }
    //
    // const getProgressWidth = () => {
    //     return isExerciseCompleted() ? 'w-100' : 'w-50'
    // }

    return (
        <>
            <div className="ex-portlet w-49-percent">
                <div className="ex-portlet__body">
                    <div className="ex-widget ex-widget--user-profile-3">
                        <div className="ex-widget__top">
                            <div onClick={() => onClickExerciseImage(exercise?.ExerciseImageUrl || personLogo)}
                                 className="ex-widget__media ex-hidden cursor-pointer">
                                <img src={exercise?.ExerciseImageUrl || personLogo} alt="exercise"/>
                            </div>
                            <div className="ex-widget__content">
                                <div className="ex-widget__head">
                                    <label className="ex-widget__username">
                                        {exercise?.ExerciseName}
                                    </label>
                                    <div className="ex-widget__action">
                                        <button
                                            type="button"
                                            className="assigned-exercise-btn"
                                            disabled={!exercise['LPTVideoUrl']}
                                            onClick={() => onclickOpenTutorial(exercise['LPTVideoUrl'])}>Tutorial
                                        </button>
                                    </div>
                                </div>
                                <div className="ex-widget__subhead">
                                    <span className='ex-mr-15'>{exercise?.TestId}</span>
                                    {exercise?.ProviderName && (
                                        <span>
                                            <i className="flaticon2-calendar-3"/>
                                            {exercise.ProviderName}
                                        </span>
                                    )}
                                </div>
                                <div className="">
                                    {/*<div className="kt-widget__progress flex-column align-items-start w-49">*/}
                                    {/*    <div className="kt-widget__text kt-mb-10">*/}
                                    {/*    <span*/}
                                    {/*        className={`kt-badge ${getBadgeProgressColor()} kt-badge--md kt-badge--inline`}>*/}
                                    {/*        {exercise?.Status}*/}
                                    {/*    </span>*/}
                                    {/*    </div>*/}
                                    {/*    <div className="progress h-5px w-100">*/}
                                    {/*        <div*/}
                                    {/*            className={`progress-bar ${getBgProgressColor()} ${getProgressWidth()}`}*/}
                                    {/*            role="progressbar"/>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                    <div className='display-flex flex-row justify-start '>
                                        <div className="display-flex flex-direction-column ex-mr-10">
                                            <span className="font-primary">Start Date</span>
                                            <span className="ex-badge ex-badge--primary ex-badge--lg ex-badge--rounded ex-badge--bold w-auto ex-padding-5">
                                                    {exercise.ExercisePlan.StartDate && format(new Date(exercise.ExercisePlan.StartDate || null), CONSTANT.DATE_FORMAT.MMM_DD_YYYY)}
                                            </span>
                                        </div>
                                        <div className="display-flex flex-direction-column">
                                            <span className="font-primary">End Date</span>
                                            <span className="ex-badge ex-badge--danger ex-badge--lg ex-badge--rounded ex-badge--bold w-auto ex-padding-5">
                                                    {exercise.ExercisePlan.EndDate && format(new Date(exercise.ExercisePlan.EndDate || null), CONSTANT.DATE_FORMAT.MMM_DD_YYYY)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Assigned / stats */}
                        <div className="ex-widget__bottom ex-mt-5">
                            <div className="ex-widget__status-row">
                                <div className="ex-widget__status">
                                    <div className="ex-widget__icon ex-mr-5">
                                        <i className="flaticon2-notepad font-primary" />
                                    </div>
                                    <div className={"displayFlex flex-direction-row"}>
                                        <div className="ex-status-label font-primary">Assigned</div>
                                        <div className="ex-status-stats">
                                            <div className="ex-stat">
                                                <span className="ex-stat-label">Reps</span>
                                                <span className="ex-stat-value">{exercise?.AssignReps}</span>
                                            </div>
                                            <div className="ex-stat">
                                                <span className="ex-stat-label">Sets</span>
                                                <span className="ex-stat-value">{exercise?.AssignSets}</span>
                                            </div>
                                            <div className="ex-stat">
                                                <span className="ex-stat-label">Hold (s)</span>
                                                <span className="ex-stat-value">{exercise?.HoldInSeconds}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* In Progress / stats */}
                        <div className="ex-widget__bottom ex-mt-5">
                            <div className="ex-widget__status-row">
                                <div className="ex-widget__status">
                                    <div className="ex-widget__icon ex-mr-5">
                                        <i className="fa fa-check-circle color-green" />
                                    </div>
                                    <div className={"displayFlex flex-direction-row"}>
                                        <div className="ex-status-label color-green">{+exercise?.AssignSets === +exercise?.CompletedSets ? `Completed` : `In Progress`}</div>
                                        <div className="ex-status-stats">
                                            <div className="ex-stat">
                                                <span className="ex-stat-label">Reps</span>
                                                <span className="ex-stat-value">{exercise?.CompletedReps}</span>
                                            </div>
                                            <div className="ex-stat">
                                                <span className="ex-stat-label">Sets</span>
                                                <span className="ex-stat-value">{exercise?.CompletedSets}</span>
                                            </div>
                                            <div className="ex-stat">
                                                <span className="ex-stat-label">Wrong Count</span>
                                                <span className="ex-stat-value">{exercise?.['TotalNoOfWrongCount'] || 0}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* keep space for alignment or potential secondary actions */}
                                <div />
                            </div>
                        </div>
                        <div className="ex-buttons-wrapper">
                            <button
                                className={`assigned-exercise-btn ex-mr-10 ${+exercise?.AssignSets === +exercise?.CompletedSets ? 'display-none': ''}`}
                                disabled={exercise.Status === CONSTANT.STATUS.COMPLETED}
                                onClick={toggleExerciseTrackingFormModal}>
                                Start Tracking
                            </button>
                            <button
                                className='assigned-exercise-btn'
                                onClick={toggleViewTrackingDetails}
                                disabled={+exercise.CompletedReps <= 0}>
                                View Tracking Details
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                isOpen={openExerciseTrackingFormModal}
                backdrop={'static'}
                className="modal-sm">
                <ModalHeader toggle={toggleExerciseTrackingFormModal}>
                    Exercise Tracking &nbsp;&nbsp;
                </ModalHeader>
                <ModalBody>
                    <ExerciseTrackingForm exercise={exercise} onSave={onSaveExerciseTracking}/>
                </ModalBody>
            </Modal>
            <Modal
                isOpen={openExercisePlanningFormModal}
                backdrop={'static'}
                className="modal-md">
                <ModalHeader toggle={toggleExercisePlanningFormModal}>
                    Exercise Plan &nbsp;&nbsp;
                </ModalHeader>
                <ModalBody>
                    <ExercisesPlanningForm exercise={exercise} onSave={onSaveExercisePlan}/>
                </ModalBody>
            </Modal>
            <VideoModal
                visible={openVideoTutorial}
                url={videoTutorialUrl}
                closeModal={toggleVideoTutorialModal}
                headerTitle='Video Tutorial'/>
            <Modal
                isOpen={openViewTrackingDetailsModal}
                backdrop={'static'}
                className="modal-xl">
                <ModalHeader toggle={toggleViewTrackingDetails}>
                    View tracking details &nbsp;&nbsp;
                </ModalHeader>
                <ModalBody>
                    <ExercisesTrackingDetails exercise={exercise}/>
                </ModalBody>
            </Modal>
            {showExerciseImage && selectedExerciseImage && (
                <Lightbox
                    medium={selectedExerciseImage}
                    large={selectedExerciseImage}
                    alt="Exercise Image"
                    hideDownload={true}
                    onClose={toggleExerciseImage}
                />
            )}
        </>
    )
};

export default ExerciseDetails;
